import React, { useState } from 'react';
import { RiSideBarLine } from 'react-icons/ri';

import { NavLink, useLocation } from 'react-router-dom';
import Styles from './Sidebar.module.scss';
import {
  MAIN_SIDEBAR_OPTIONS,
  OTHER_OPTIONS,
} from '../../constants/SidebarItems';

import ImageView from 'Components/Image/ImageView';
import { UserProfileCard } from 'Components/UserProfileCard/UserProfileCard';
import { ManageSubscriptionCard } from 'Components/ManageSubscriptionCard/ManageSubscriptionCard';
import UpgradeModal from 'Containers/Modal/UpgradeModal/UpgradeModal';
import { useNavigate } from 'react-router-dom';

function Sidebar({ planName, isOpen, isCollapsed, onToggleCollapse }) {
  const location = useLocation();
  const [showUpgradeModal, setShowUpgradeModal] = useState(false);
  const navigate = useNavigate();
  const [tooltipPosition, setTooltipPosition] = useState({});

  const handleMouseEnter = (e, optionId) => {
    if (isCollapsed) {
      const rect = e.currentTarget.getBoundingClientRect();
      setTooltipPosition({
        [optionId]: rect.top + rect.height / 2
      });
    }
  };

  const handleMouseLeave = (optionId) => {
    setTooltipPosition(prev => {
      const newPos = { ...prev };
      delete newPos[optionId];
      return newPos;
    });
  };

  const isMobile = window.matchMedia('(max-width: 1023px)').matches;

  return (
    <div
      className={`${Styles.Sidebar} ${isCollapsed ? Styles.SidebarCollapsed : ''}`}
      style={{
        display: isOpen ? 'flex' : 'none',
      }}
    >
      <div className={Styles.SidebarScrollWrapper}>
        <div style={{ paddingBottom: '16px', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          {!isCollapsed ? (
            <>
              <div style={{ cursor: 'pointer', flex: 1 }} onClick={() => navigate('/')}>
                <ImageView
                  src="/Images/vocable_sidebar_logo.svg"
                  alt="Vocable"
                  class="img-fluid logo-img"
                />
              </div>
              {!isMobile && (
                <button
                  className={Styles.toggleButton}
                  onClick={onToggleCollapse}
                  title="Collapse sidebar"
                >
                  <RiSideBarLine size={20} />
                </button>
              )}
            </>
          ) : (
            !isMobile && (
              <button
                className={Styles.toggleButtonCollapsed}
                onClick={onToggleCollapse}
                title="Expand sidebar"
              >
                <RiSideBarLine size={20} />
              </button>
            )
          )}
        </div>
        <nav className={Styles.Accordion}>
          {MAIN_SIDEBAR_OPTIONS().map((option) => {
            if (planName === 'Basic Plan' && option.id === 'teams') {
              return (
                <div
                  key={option.id}
                  className={Styles.navItemWrapper}
                  onMouseEnter={(e) => handleMouseEnter(e, option.id)}
                  onMouseLeave={() => handleMouseLeave(option.id)}
                >
                  <NavLink
                    to={'#'} // Prevent navigation if disabled
                    className={Styles.sidebarListItemProPlan}
                    onClick={(event) => {
                      setShowUpgradeModal(true);
                    }}
                  >
                    <div className={option.new && Styles.item_icon}>
                      {option.icon}
                    </div>
                    {!isCollapsed && (
                      <span className={Styles.listItemText}>{option.label}</span>
                    )}
                  </NavLink>
                  {isCollapsed && (
                    <div
                      className={Styles.sidebarTooltip}
                      style={{
                        top: tooltipPosition[option.id] ? `${tooltipPosition[option.id]}px` : undefined,
                        opacity: tooltipPosition[option.id] ? 1 : 0,
                        visibility: tooltipPosition[option.id] ? 'visible' : 'hidden'
                      }}
                    >
                      {option.label}
                    </div>
                  )}
                </div>
              );
            }
            return (
              <div
                key={option.id}
                className={Styles.navItemWrapper}
                onMouseEnter={(e) => handleMouseEnter(e, option.id)}
                onMouseLeave={() => handleMouseLeave(option.id)}
              >
                <NavLink
                  to={option.new ? '#' : option.path} // Prevent navigation if disabled
                  className={({ isActive }) =>
                    option.new
                      ? Styles.sidebarListItemDisabled
                      : option.id === 'integration'
                        ? location.pathname === '/integrations'
                          ? Styles.sidebarListItemActive
                          : Styles.sidebarListItemInactive
                        : isActive
                          ? Styles.sidebarListItemActive
                          : Styles.sidebarListItemInactive
                  }
                  onClick={(event) => {
                    if (option.new) {
                      event.preventDefault(); // Prevent default behavior if disabled
                    }
                  }}
                >
                  <div className={option.new && Styles.item_icon}>
                    {option.icon}
                  </div>
                  {!isCollapsed && (
                    <span className={Styles.listItemText}>{option.label}</span>
                  )}
                  {option.new && (
                    <span className={Styles.comming_soon}>Coming Soon</span>
                  )}
                </NavLink>
                {isCollapsed && (
                  <div
                    className={Styles.sidebarTooltip}
                    style={{
                      top: tooltipPosition[option.id] ? `${tooltipPosition[option.id]}px` : undefined,
                      opacity: tooltipPosition[option.id] ? 1 : 0,
                      visibility: tooltipPosition[option.id] ? 'visible' : 'hidden'
                    }}
                  >
                    {option.label}
                  </div>
                )}
              </div>
            );
          })}
        </nav>
        <div>
          {!isCollapsed && (
            <span className={Styles.Others_text}>Other</span>
          )}
          <nav className={`${Styles.Accordion} ${Styles.otherNav}`}>
            {OTHER_OPTIONS.map((option) => {
              // Handle external links differently
              if (option.external) {
                return (
                  <div
                    key={option.id}
                    className={Styles.navItemWrapper}
                    onMouseEnter={(e) => handleMouseEnter(e, option.id)}
                    onMouseLeave={() => handleMouseLeave(option.id)}
                  >
                    <a
                      href={option.path}
                      target="_blank"
                      rel="noopener noreferrer"
                      className={Styles.sidebarListItemInactive}
                    >
                      <div>
                        {option.icon}
                      </div>
                      {!isCollapsed && (
                        <span className={`${Styles.listItemText} ${Styles.listItemTextSmall}`}>{option.label}</span>
                      )}
                    </a>
                    {isCollapsed && (
                      <div
                        className={Styles.sidebarTooltip}
                        style={{
                          top: tooltipPosition[option.id] ? `${tooltipPosition[option.id]}px` : undefined,
                          opacity: tooltipPosition[option.id] ? 1 : 0,
                          visibility: tooltipPosition[option.id] ? 'visible' : 'hidden'
                        }}
                      >
                        {option.label}
                      </div>
                    )}
                  </div>
                );
              }

              return (
                <div
                  key={option.id}
                  className={Styles.navItemWrapper}
                  onMouseEnter={(e) => handleMouseEnter(e, option.id)}
                  onMouseLeave={() => handleMouseLeave(option.id)}
                >
                  <NavLink
                    to={option.new ? '#' : option.path} // Prevent navigation if disabled
                    className={({ isActive }) =>
                      option.new
                        ? Styles.sidebarListItemDisabled
                        : isActive
                          ? Styles.sidebarListItemActive
                          : Styles.sidebarListItemInactive
                    }
                    onClick={(event) => {
                      if (option.new) {
                        event.preventDefault(); // Prevent default behavior if disabled
                      }
                    }}
                  >
                    <div className={option.new && Styles.item_icon}>
                      {option.icon}
                    </div>
                    {!isCollapsed && (
                      <span className={Styles.listItemText}>{option.label}</span>
                    )}
                  </NavLink>
                  {isCollapsed && (
                    <div
                      className={Styles.sidebarTooltip}
                      style={{
                        top: tooltipPosition[option.id] ? `${tooltipPosition[option.id]}px` : undefined,
                        opacity: tooltipPosition[option.id] ? 1 : 0,
                        visibility: tooltipPosition[option.id] ? 'visible' : 'hidden'
                      }}
                    >
                      {option.label}
                    </div>
                  )}
                </div>
              );
            })}
          </nav>
        </div>
      </div>
      {!isCollapsed && (
        <div className={Styles.SidebarBottomSection}>
          <ManageSubscriptionCard />
        </div>
      )}
      {showUpgradeModal && (
        <UpgradeModal
          show={showUpgradeModal}
          onHide={() => setShowUpgradeModal(false)}
        />
      )}
    </div>
  );
}

export default Sidebar;
